// extracted by mini-css-extract-plugin
export default {"typingContainer":"TypingIndicator_typingContainer__2lYaA","typingDot":"TypingIndicator_typingDot__z786Z","typingAnimation":"TypingIndicator_typingAnimation__gerlj"};